import(/* webpackMode: "eager" */ "/codebuild/output/src1834264613/src/skop-manage/src/app/[locale]/error.tsx");
